import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { BatchStockMovementPayload, BatchStockTransferPayload } from '@/types/product';

export function useCreateStockMovement() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: Record<string, unknown>) => api.post('/stock/movements', data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['stock'] }),
  });
}

export function useCreateBatchStockMovement() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: BatchStockMovementPayload) => api.post('/stock/movements/batch', data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['stock'] }),
  });
}

export function useCreateStockTransfer() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: Record<string, unknown>) => api.post('/stock/transfer', data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['stock'] }),
  });
}

export function useCreateBatchStockTransfer() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: BatchStockTransferPayload) => api.post('/stock/transfer/batch', data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['stock'] }),
  });
}
